module.exports = __webpack_public_path__ + "assets/images/8efa21e7a06043bd8e69f378ff3cd1bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/rfr-web/rfr-web-1.jpg
// module id = 795
// module chunks = 0